import { render, staticRenderFns } from "./decoratePlan.vue?vue&type=template&id=881ba416&scoped=true&"
import script from "./decoratePlan.vue?vue&type=script&lang=js&"
export * from "./decoratePlan.vue?vue&type=script&lang=js&"
import style0 from "./decoratePlan.vue?vue&type=style&index=0&id=881ba416&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ba416",
  null
  
)

export default component.exports